/**
 * Outbound partner referral tracking.
 *
 * Simply Health Rx links out to partner businesses in the Simply Health Center.
 * When a visitor clicks through to a partner, we tag the destination URL so the
 * partner's own analytics and ad tools can see the visit was referred by us —
 * the basis for paid referral arrangements — and we record the click in PostHog
 * so we have our own count of how many people we send each partner.
 */

/** Identifies Simply Health Rx as the referral source on outbound links. */
export const REFERRAL_SOURCE = "simplyhealthrx";

/** UTM campaign grouping all Simply Health Center partner referrals. */
export const REFERRAL_CAMPAIGN = "simply-health-center";

/**
 * Append referral tracking parameters to a partner's URL so their analytics
 * attribute the visit to Simply Health Rx. Uses standard UTM parameters
 * (recognized automatically by Google Analytics, Meta, and most ad platforms)
 * and preserves any query string the partner URL already has. Falls back to the
 * original URL if it can't be parsed.
 */
export function withReferral(url: string): string {
  try {
    const target = new URL(url);
    target.searchParams.set("utm_source", REFERRAL_SOURCE);
    target.searchParams.set("utm_medium", "referral");
    target.searchParams.set("utm_campaign", REFERRAL_CAMPAIGN);
    return target.toString();
  } catch {
    return url;
  }
}
